import { action, payload } from 'ts-action'
import { IShift } from 'models/Shift'

// action for saving the original shift that we are editing/copying
export const GetOriginalShift = action('GetOriginalShift', payload<IShift>())

export const OriginalShiftFetching = action(
  'OriginalShiftFetching',
  payload<boolean>(),
)

export const ClearOriginalShiftReducer = action('ClearOriginalShiftReducer')
